import axios from "axios";
import config from "../config";
 
const apiBaseUrl = config.REACT_APP_API_BASE_URL;
export const formatReceiptData = (orderItems,imageLogo,restaurantName
   , restaurantAddress
    ,currentUser,tableNumber,
    selectedOrders,
    isSeperatedOrderChit) => {
    const selectedPrinterId=localStorage.getItem("selectedPrinterId");
    const groupedOrders = orderItems.reduce((acc, item) => {
        // Group addOns by their group name

        if(item.product.addOns == []){
            return;
        }
        const groupedAddOns = item.product.addOns
            ? item.product.addOns.reduce((groupAcc, addOn) => {
                  if (!groupAcc[addOn.group]) {
                      groupAcc[addOn.group] = [];
                  }
                  groupAcc[addOn.group].push(addOn.name);
                  return groupAcc;
              }, {})
            : {};

        // Serialize grouped addOns for comparison
        const addOnsKey = Object.entries(groupedAddOns)
            .sort(([groupA], [groupB]) => groupA.localeCompare(groupB)) // Sort groups alphabetically
            .map(([group, names]) => `${group}:${names.sort().join(",")}`) // Sort and join names in each group
            .join("|"); // Join groups with "|"

        // Generate a unique key based on product attributes
        const key = `${item.product.name}__${item.remarks || "__no_remark__"}__${addOnsKey}`;

        if (!acc[key]) {
            acc[key] = {
                ...item,
                quantity: item.quantity,
            };
        } else {
            // Merge quantities of identical items
            acc[key].quantity += item.quantity;
        }
        return acc;
    }, {});

    return {
        logo: imageLogo,
        resName: restaurantName,
        address: restaurantAddress,
        cashierName: currentUser,
        orders: Object.values(groupedOrders),
        tableNumber: String(tableNumber),
        selectedOrders,
        totalItems: Object.values(groupedOrders).reduce((sum, item) => sum + item.quantity, 0),
        selectedPrinterId:selectedPrinterId,
        isSeperatedOrderChit:isSeperatedOrderChit
    };
};


export const  printToKitchen = async (receiptData) => {
    const response = await axios.post(`${apiBaseUrl}/api/printorderreceipt`,
        receiptData,
        {
            headers: {
                'Content-Type': 'application/json',
                // Add any authentication headers if needed
                Authorization: `Bearer ${JSON.parse(localStorage.getItem('auth')).token}`
            }
        }
    );
    return response;
}



